import { render, staticRenderFns } from "./ModuleClientRecordList.vue?vue&type=template&id=10ca8950&scoped=true&lang=pug&"
import script from "./ModuleClientRecordList.vue?vue&type=script&lang=js&"
export * from "./ModuleClientRecordList.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClientRecordList.vue?vue&type=style&index=0&id=10ca8950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca8950",
  null
  
)

export default component.exports